<script lang="ts" setup>
import { VueFinalModal } from 'vue-final-modal'

const modals = useModalsStore()
</script>

<template>
  <VueFinalModal
    v-model="modals.isSeatWidgetModalOpen"
    class="app-modal-seat-widget"
    content-class="app-modal-seat-widget__content"
    overlay-transition="vfm-fade"
    content-transition="vfm-fade"
  >
    <AppModalSeatWidgetContent />
  </VueFinalModal>
</template>

<style lang="scss">
.app-modal-seat-widget {
}

.app-modal-seat-widget__content {
  width: 100%;
  height: 100%;
  pointer-events: none;

  .row {
    min-height: 100%;
  }
}

.app-modal-seat-widget__iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
